<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
</script>

<template>
  <AppLayout title="Report Bugs">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        New Bug
      </h2>
    </template>

    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 bg-white rounded mb-5">
      <div class="max-w-3xl mx-auto">
        <p class="text-base text-gray-700 leading-7">
          Please email neal@uniforms.net any errors or bugs you find using the CRM.
          <br>
          Include a screen shot, URL and description of the error for the programmers.
        </p>
      </div>
    </div>
  </AppLayout>
</template>
